import {ExternalLinkPoint} from 'main/factories/usecases/endpoints';

export const getHealthEmergencyEndpoint = (useV3 = false): ExternalLinkPoint =>
	useV3 ? ExternalLinkPoint.emergencyV3 : ExternalLinkPoint.emergency;
